export default "__VITE_ASSET__DkDOlwkh__"